/*
 * @Author: changcheng
 * @LastEditTime: 2024-11-13 10:08:39
 */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState, store } from "@root/store/index";
import { Space, Menu, Dropdown, Modal } from "antd";
import { useDispatch } from "react-redux";
import {
  getHomemMenus,
  queryAdvertisementImg,
  updateUserRole,
  querSaveUserWatchTime,
} from "@root/common/service";
import { UserOutlined, DownOutlined, CheckOutlined } from "@ant-design/icons";

import Login from "../../home/login/index";
import { userRoleMap, postLeaveAdvertisementTime } from "@common/utils";

import { useNavigate } from "react-router-dom";
import "../_style.scss";
import { LogoutOutlined } from "@ant-design/icons";
import { setUserInfo } from "@root/reducers/user";
import ShowConfirm from "../showConfirm/index";
import ConfirmUserInfo from "@root/pages/home/confirmUserInfo/index";
import {
  Breadcrumbs,
  BreadcrumbItem,
  BreadcrumbParentsItem,
  HomeMenu,
} from "@root/common/interface/result";
import loginImg from "@root/img/login.png";
import registerImg from "@root/img/register.png";
import { setRegisterType } from "@root/reducers/register";
import { setAdvertisementData } from "@root/reducers/advertisement";
export default function MenuComponent(props: {
  defaultKeys: string;
  setDefaultKeys: (val: string) => void;
  setInitBreadcrumbs: (val: object) => void;
}) {
  var startTime = new Date().valueOf() / 1000;
  const { defaultKeys, setDefaultKeys, setInitBreadcrumbs } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let [menuItems, setMenuItems] = useState<HomeMenu[]>([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmUserInfo, setShowConfirmUserInfo] = useState(false);
  let [initMenuItems, setInitMenuItems] = useState<HomeMenu[]>([]);
  const userInfo = useSelector((state: RootState) => state.userInfo);
  const {
    access_token,
    userDetailInfo,
    roleMap = [],
    baseUserCategory,
  } = userInfo;
  const logOut = async () => {
    // await queryLogOut();
    dispatch(
      // 存储token，因为获取用户信息依赖token
      setUserInfo({
        access_token: "",
      })
    );
    // 强制刷新一下，因为涉及token，顺便返回首页
    navigate(`/home/index`);
    // window.location.reload();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  /**
   * 修改用户角色
   */
  const updateUserRoleFn = async (roleId: string) => {
    await updateUserRole(roleId);
    // 更新当前用户的角色
    dispatch(
      setUserInfo({
        ...userInfo,
        baseUserCategory: roleId,
      })
    );
  };

  /**
   * 设置面包屑数据源 (该数据是菜单数据的变式), 数据格式：key=path=路径名，value=该路径的完整路径相关数组
   */
  const processMenusDataToBreadcrumbsData = (
    menus: HomeMenu[],
    parentMenus: BreadcrumbParentsItem[],
    allBreadcrumbsData: Breadcrumbs
  ) => {
    menus.forEach((v) => {
      if (!v.parentMenus) {
        v.parentMenus = [...parentMenus];
      }
      v.parentMenus.push({ title: v.name, path: v.path });
      if (v.child && v.child.length > 0) {
        processMenusDataToBreadcrumbsData(
          v.child,
          v.parentMenus,
          allBreadcrumbsData
        );
      } else if (v.path) {
        const breadcrumbItem: BreadcrumbItem = {
          title: v.parentMenus
            .map((v1: BreadcrumbParentsItem) => `${v1.title}`)
            .join("/"),
          columnId: v.id,
          parents: v.parentMenus,
        };
        allBreadcrumbsData[v.path] = breadcrumbItem;
      }
    });
  };

  /**
   * 获取首页菜单
   */
  const queryHomemMenus = async () => {
    const { data } = await getHomemMenus();

    // 面包屑数据
    const allBreadcrumbsData = {};
    processMenusDataToBreadcrumbsData(data, [], allBreadcrumbsData);
    setInitBreadcrumbs(allBreadcrumbsData);

    // 菜单数据
    setInitMenuItems(data as HomeMenu[]);
  };
  useEffect(() => {
    queryHomemMenus();
  }, []);

  /**
   * 更新首页菜单
   */
  useEffect(() => {
    const menusData = access_token
      ? initMenuItems
      : initMenuItems.filter((v) => v.id !== 5);
    setMenuItems([...menusData]);
  }, [access_token, initMenuItems]);
  /**
   * 获取广告数据
   */
  const getAdvertisementData = async () => {
    const { data } = await queryAdvertisementImg();
    dispatch(
      setAdvertisementData({
        //banner广告
        xy_home_banner: sortAdvertistData(handleAdvertisementData(data, "xy_home_banner")),
        //首页侧边广告图
        xy_home_erect: handleAdvertisementData(data, "xy_home_erect"),
        // 县域-首页-底部广告部
        xy_home_bottom: handleAdvertisementData(data, "xy_home_bottom"),
        // 县域-首页弹窗广告
        xy_home_pop: handleAdvertisementData(data, "xy_home_pop"),
        // 县域-首页飘窗广告
        xy_home_slip: handleAdvertisementData(data, "xy_home_slip"),
        //县域-登录页广告
        xy_home_login: handleAdvertisementData(data, "xy_home_login"),
        //县域-导航页广告
        xy_navigation: handleAdvertisementData(data, "xy_navigation"),
        //县域-视频底部广告
        xy_video_bottom: handleAdvertisementData(data, "xy_video_bottom"),
      })
    );
    const popData = handleAdvertisementData(data, "xy_home_pop");
    if (popData.length) {
      Modal.success({
        title: "重磅来袭!",
        content: (
          <img
            src={popData[0].imageUrl}
            alt=""
            width={"100%"}
            onClick={() => {
              popData[0].url && window.open(popData[0].url);
            }}
          />
        ),
        width: "1000px",
        onOk: () => {
          postLeaveAdvertisementTime(popData, startTime);
        },
      });
    }
  };
  const handleAdvertisementData = (data: any, name: string) => {
    return data
      .filter((item: any) => item.position === name)
      .map((it: any) => {
        return {
          ...it,
          url: it.url === "/" ? "" : it.url,
        };
      });
  };
  const sortAdvertistData = (data:any[])=>{
    return data.sort((a, b) => {
      return a.rank - b.rank
    })
  }
  useEffect(() => {
    getAdvertisementData();
  }, []);
  const menu = (
    <Menu>
      {roleMap.map((item, idx) => (
        <Menu.Item
          key={idx}
          onClick={() => {
            updateUserRoleFn(item);
          }}
        >
          <Space>
            <span>{userRoleMap.get(item)}</span>
            {baseUserCategory === item && <CheckOutlined color="blue" />}
          </Space>
        </Menu.Item>
      ))}
      <Menu.Divider />
      <Menu.Item onClick={logOut}>
        <Space>
          <span>退出账户</span>
          <LogoutOutlined />
        </Space>
      </Menu.Item>
    </Menu>
  );
  /**
   * 调用接口保存状态
   */
  const saveHomePageSaveEnterInerface = (
    sourceId: number,
    sourceName: string
  ) => {
    var startTime = new Date().valueOf() / 1000;
    let data = [
      {
        sourceType: 4,
        sourceId,
        sourceName,
      },
    ];
    const {
      userInfo: { uumsId = "" },
    } = store.getState();
    const leaveTime = Math.floor(new Date().valueOf() / 1000 - startTime);
    data.length && querSaveUserWatchTime(data, leaveTime, uumsId, 2);
  };
  const onClick = (e: HomeMenu) => {
    const { menuType, isFrame, path, name, id } = e;
    if (menuType === "C" || !path) {
      return false;
    }
    if (isFrame === "Y") {
      if (["培训课程", "水平测试"].includes(name)) {
        saveHomePageSaveEnterInerface(id, name);
      }
      window.open(path);
    } else {
      if (
        [
          "通知公告",
          "典型案例",
          "政策法规",
          "热门直播",
          "新冠专项",
          "湖南站",
          "指南发布",
          "广西站",
          "江苏站",
          "中心类课程",
          "学科类课程",
        ].includes(name)
      ) {
        saveHomePageSaveEnterInerface(id, name);
      }
      navigate(path);
      setDefaultKeys(path);
    }
  };
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="menu_container">
      <div className="menu_info">
        <Menu mode="horizontal" className="menu" selectedKeys={[defaultKeys]}>
          {menuItems.map((item: HomeMenu) =>
            item.child && item.child.length > 0 ? (
              <Menu.SubMenu
                key={item.path ? item.path : item.id}
                popupClassName={"header-menu-sub-popup"}
                title={
                  <Space>
                    <span className="menu-name">{item.name}</span>
                    {/* <DownOutlined /> */}
                  </Space>
                }
              >
                {item.child.map((itemChild: HomeMenu) => (
                  <Menu.Item
                    key={itemChild.path ? itemChild.path : itemChild.id}
                    onClick={() => {
                      onClick(itemChild);
                    }}
                  >
                    <span className="sub-menu-name">{itemChild.name}</span>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            ) : (
              <Menu.Item
                key={item.path ? item.path : item.id}
                onClick={() => {
                  onClick(item);
                }}
              >
                <Space>
                  <span className="menu-name">{item.name}</span>
                </Space>
              </Menu.Item>
            )
          )}
        </Menu>

        {!access_token && (
          <Space className="login-register-item">
            <span
              className="login-item"
              onClick={() => {
                navigate("/login");
              }}
            >
              {/* <UserOutlined /> */}
              <img src={loginImg} alt="" />
              登录
            </span>
          </Space>
        )}
        {access_token && (
          <Dropdown className="user-detail-info" overlay={menu}>
            <Space>
              <UserOutlined />
              <span className="user-detail-nickname">
                {userDetailInfo && userDetailInfo.nickName}
                <DownOutlined />
              </span>
            </Space>
          </Dropdown>
        )}
      </div>
      <Login showLogin={showLogin} setShowLogin={setShowLogin} />
      <ShowConfirm
        showConfirm={showConfirm}
        setShowConfirm={setShowConfirm}
        setShowConfirmUserInfo={setShowConfirmUserInfo}
      />
      <ConfirmUserInfo
        showConfirmUserInfo={showConfirmUserInfo}
        setShowConfirmUserInfo={setShowConfirmUserInfo}
      />
    </div>
  );
}
